"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("../style.css"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up8"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down8"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus3"));
var _InlineWysiwyg = _interopRequireDefault(require("../InlineWysiwyg"));
var _ObjectivesList = _interopRequireDefault(require("./ObjectivesList"));
var _SectionTitle = _interopRequireDefault(require("../SectionTitle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var LearningObjectives = function LearningObjectives(_ref) {
  var formProps = _ref.formProps;
  var sections = formProps.values.courseDescription.learningObjectives.sections;
  var setLearningObjectiveSections = function setLearningObjectiveSections(learningObjectiveSections) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        learningObjectives: _objectSpread(_objectSpread({}, formProps.values.courseDescription.learningObjectives), {}, {
          sections: learningObjectiveSections
        })
      })
    }));
  };
  var onClickSlide = function onClickSlide(index, direction) {
    var updatedSections = _toConsumableArray(sections);
    if (direction === 'up') {
      var temp = updatedSections[index - 1];
      updatedSections[index - 1] = updatedSections[index];
      updatedSections[index] = temp;
    } else if (direction === 'down') {
      var _temp = updatedSections[index + 1];
      updatedSections[index + 1] = updatedSections[index];
      updatedSections[index] = _temp;
    } else {
      console.error("onClickSlide should be passed a direction of 'up' or 'down'");
    }
    setLearningObjectiveSections(updatedSections);
  };
  var onClickAddSection = function onClickAddSection() {
    var learningObjectiveSections = _toConsumableArray(sections);
    var highestKey = 0;
    learningObjectiveSections.forEach(function (section) {
      if (section.key > highestKey) {
        highestKey = section.key;
      }
    });
    learningObjectiveSections.push({
      heading: '',
      statement: '',
      objectives: [],
      key: highestKey + 1
    });
    setLearningObjectiveSections(learningObjectiveSections);
  };
  var onClickDeleteSection = function onClickDeleteSection(index) {
    var updatedSections = sections.filter(function (section, i) {
      return i !== index;
    });
    setLearningObjectiveSections(updatedSections);
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Learning Objectives"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "learningObjectives",
    placeholder: "Learning Objectives"
  }), sections.map(function (section, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "learning-objectives-section-".concat(section.key),
      className: "".concat(_style["default"].dragContainer, " ").concat(_style["default"].learningObjectivesSection)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].dragAndDropContent
    }, sections.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].learningObjectiveButtons
    }, index > 0 && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return onClickSlide(index, 'up');
      }
    }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), " Slide Up"), index < sections.length - 1 && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return onClickSlide(index, 'down');
      }
    }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null), " Slide Down"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return onClickDeleteSection(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null), " Delete")), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
      name: "courseDescription.learningObjectives.sections[".concat(index, "].heading"),
      label: "Heading"
    }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
      name: "courseDescription.learningObjectives.sections[".concat(index, "].statement"),
      label: "Statement"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, "Objectives"), /*#__PURE__*/_react["default"].createElement(_ObjectivesList["default"], {
      formProps: formProps,
      section: section,
      sectionIndex: index,
      setLearningObjectiveSections: setLearningObjectiveSections
    }))));
  }), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClickAddSection,
    type: "button",
    className: "btn btn-default ".concat(_style["default"].addSectionButton)
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), " Add Learning Objective Section")));
};
var _default = LearningObjectives;
exports["default"] = _default;